var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content album-add-page album-studio",
      attrs: { "aria-busy": _vm.showCreateProgress },
    },
    [
      _c(
        "el-form",
        {
          ref: "createAlbumRequest",
          staticClass: "demo-ruleForm album-form",
          attrs: {
            model: _vm.createAlbumRequest,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c("div", { staticClass: "page-header-card" }, [
            _c("div", { staticClass: "album-heading" }, [
              _c("div", { staticClass: "album-heading__icon" }, [
                _c("i", {
                  staticClass: "el-icon-picture-outline",
                  attrs: { "aria-hidden": "true" },
                }),
              ]),
              _c("div", [
                _c("span", { staticClass: "album-heading__eyebrow" }, [
                  _vm._v("THƯ VIỆN ẢNH"),
                ]),
                _c("h2", { staticClass: "page-title" }, [
                  _vm._v("Tạo album mới"),
                ]),
                _c("p", { staticClass: "page-description" }, [
                  _vm._v(
                    "\n          Điền thông tin album, chọn đối tượng hiển thị và tải ảnh lên theo đúng giới hạn hệ thống.\n        "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-badges" }, [
              _c("div", { staticClass: "summary-badge" }, [
                _c("span", { staticClass: "summary-badge__label" }, [
                  _vm._v("Đối tượng"),
                ]),
                _c("strong", { staticClass: "summary-badge__value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.createAlbumRequest.selectObject === "student"
                          ? "Lớp"
                          : "Trường"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "form-shell" },
            [
              _c("div", { staticClass: "album-form-main" }, [
                _c(
                  "section",
                  { staticClass: "section-card album-info-section" },
                  [
                    _c("div", { staticClass: "section-heading" }, [
                      _c("h3", { staticClass: "section-title" }, [
                        _c("i", {
                          staticClass: "el-icon-document",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v("Thông tin album"),
                      ]),
                      _c("p", { staticClass: "section-description" }, [
                        _vm._v("Nhập thông tin cơ bản để tạo album mới."),
                      ]),
                    ]),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { xs: 24, md: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "field-item",
                                attrs: {
                                  label: "Tên album",
                                  prop: "albumName",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "Nhập tên album" },
                                  model: {
                                    value: _vm.createAlbumRequest.albumName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.createAlbumRequest,
                                        "albumName",
                                        $$v
                                      )
                                    },
                                    expression: "createAlbumRequest.albumName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { xs: 24, md: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "field-item",
                                attrs: { label: "Đối tượng" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      "popper-class": "album-studio-popper",
                                      placeholder: "Chọn đối tượng",
                                    },
                                    on: { change: _vm.handleChangeObject },
                                    model: {
                                      value:
                                        _vm.createAlbumRequest.selectObject,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createAlbumRequest,
                                          "selectObject",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "createAlbumRequest.selectObject",
                                    },
                                  },
                                  _vm._l(_vm.listSelectObject, function (item) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.id,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      },
                                      [_c("span", [_vm._v(_vm._s(item.label))])]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "description-item",
                        attrs: { label: "Mô tả", prop: "desc" },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            rows: 4,
                            placeholder: "Nhập mô tả cho album",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.createAlbumRequest.albumDescription,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.createAlbumRequest,
                                "albumDescription",
                                $$v
                              )
                            },
                            expression: "createAlbumRequest.albumDescription",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.createAlbumRequest.selectObject === "student"
                  ? _c(
                      "section",
                      { staticClass: "section-card album-audience-section" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "section-heading section-heading--space-between",
                          },
                          [
                            _c("div", [
                              _c("h3", { staticClass: "section-title" }, [
                                _c("i", {
                                  staticClass: "el-icon-user",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v("Phạm vi học sinh"),
                              ]),
                              _c("p", { staticClass: "section-description" }, [
                                _vm._v(
                                  "Chọn học sinh áp dụng cho album theo từng lớp."
                                ),
                              ]),
                            ]),
                            _c(
                              "Phase2ActionButton",
                              {
                                staticClass: "student-select-button",
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-user",
                                },
                                on: { click: _vm.clickSelectStudent },
                              },
                              [
                                _vm._v(
                                  "\n              Chọn học sinh trong lớp\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "student-list-panel" }, [
                          _c(
                            "div",
                            { staticClass: "student-list-panel__header" },
                            [
                              _c("div", [
                                _c(
                                  "h4",
                                  { staticClass: "student-list-title" },
                                  [_vm._v("Danh sách học sinh")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "student-list-subtitle" },
                                  [
                                    _vm._v(
                                      "Đã chọn " +
                                        _vm._s(
                                          _vm.createAlbumRequest.kids.length
                                        ) +
                                        " học sinh"
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.createAlbumRequest.kids &&
                              _vm.createAlbumRequest.kids.length
                                ? _c("el-input", {
                                    staticClass: "student-list-search",
                                    attrs: {
                                      clearable: "",
                                      "prefix-icon": "el-icon-search",
                                      placeholder: "Tìm theo tên hoặc lớp",
                                      label: "Tìm học sinh đã chọn",
                                    },
                                    model: {
                                      value: _vm.selectedStudentSearch,
                                      callback: function ($$v) {
                                        _vm.selectedStudentSearch = $$v
                                      },
                                      expression: "selectedStudentSearch",
                                    },
                                  })
                                : _vm._e(),
                              _vm.selectedStudentSearch.trim()
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "student-search-count",
                                      attrs: { role: "status" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Tìm thấy " +
                                          _vm._s(
                                            _vm.filteredSelectedKids.length
                                          ) +
                                          " học sinh\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.createAlbumRequest.kids.length === 0
                            ? _c(
                                "div",
                                { staticClass: "student-empty-state" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-user-solid student-empty-state__icon",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "student-empty-state__title",
                                    },
                                    [_vm._v("Chưa có học sinh nào được chọn")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "student-empty-state__desc",
                                    },
                                    [
                                      _vm._v("\n                Nhấn "),
                                      _c("strong", [
                                        _vm._v("Chọn học sinh trong lớp"),
                                      ]),
                                      _vm._v(
                                        " để thêm học sinh vào album này.\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm.filteredSelectedKids.length === 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "student-search-empty",
                                  attrs: { role: "status" },
                                },
                                [
                                  _vm._v(
                                    "\n              Không tìm thấy học sinh phù hợp.\n            "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "answer_apply" },
                                _vm._l(
                                  _vm.filteredSelectedKids,
                                  function (kid, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "kid-row" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "kid-row__icon-wrap" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-check kid-row__icon",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "kid-row__content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "kid-row__name" },
                                              [_vm._v(_vm._s(kid.kidsName))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "kid-row__meta" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.parseKidStatusVietnamese(
                                                        kid.statusKids
                                                      )
                                                    ) +
                                                    " • " +
                                                    _vm._s(kid.className) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "section",
                { staticClass: "section-card album-upload-section" },
                [
                  _c("div", { staticClass: "section-heading" }, [
                    _c("h3", { staticClass: "section-title" }, [
                      _c("i", {
                        staticClass: "el-icon-upload",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("Hình ảnh album"),
                    ]),
                    _c("p", { staticClass: "section-description" }, [
                      _vm._v(
                        "Kéo thả hoặc chọn ảnh từ máy, kiểm tra ảnh trước khi lưu album."
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "upload-toolbar" }, [
                    _c("div", { staticClass: "upload-left" }, [
                      _c("div", { staticClass: "upload-note-card" }, [
                        _c("span", { staticClass: "upload-note-card__label" }, [
                          _vm._v("Giới hạn"),
                        ]),
                        _c(
                          "strong",
                          { staticClass: "upload-note-card__value" },
                          [
                            _vm._v(
                              _vm._s("Tối đa " + _vm.albumMaxNumber + " ảnh")
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "selected-summary" },
                        [
                          _vm.fileList && _vm.fileList.length > 0
                            ? [
                                _c("img", {
                                  staticClass: "selected-summary__thumb",
                                  attrs: {
                                    src: _vm.getPreview(_vm.fileList[0]),
                                    alt: "ảnh",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "selected-summary__text" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.fileList.length) +
                                        " ảnh đã chọn"
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "clear-selected",
                                    attrs: { type: "text" },
                                    on: { click: _vm.clearSelected },
                                  },
                                  [_vm._v("Xóa")]
                                ),
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "selected-summary__empty" },
                                  [_vm._v("Chưa có ảnh")]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "upload-right" }, [
                      _c(
                        "div",
                        { staticClass: "progress-wrap" },
                        [
                          _vm.showProgress
                            ? _c("el-progress", {
                                staticClass: "upload-progress",
                                attrs: {
                                  percentage: _vm.percentage,
                                  color: _vm.colors,
                                },
                              })
                            : _vm._e(),
                          _vm.showProgress
                            ? _c("div", { staticClass: "progress-label" }, [
                                _vm._v(_vm._s(_vm.percentage) + "%"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("el-upload", {
                    ref: "upload",
                    staticClass: "upload-area",
                    attrs: {
                      action: "#",
                      drag: "",
                      "list-type": "picture-card",
                      "auto-upload": false,
                      "file-list": _vm.fileList,
                      "on-change": _vm.handleChangePicture,
                      "on-remove": _vm.handleRemove,
                      "before-remove": _vm.beforeRemove,
                      multiple: "",
                      limit: _vm.albumMaxNumber,
                      "on-exceed": _vm.handleExceed,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "upload-trigger" }, [
                              _c("i", {
                                staticClass:
                                  "el-icon-upload upload-trigger__icon",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _c(
                                "strong",
                                { staticClass: "upload-trigger__text" },
                                [_vm._v("Kéo thả ảnh vào đây")]
                              ),
                              _c(
                                "span",
                                { staticClass: "upload-trigger__description" },
                                [
                                  _vm._v(
                                    "Chọn nhiều ảnh cùng lúc hoặc bấm để chọn từ máy"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "upload-trigger__button" },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" Chọn ảnh từ máy"),
                                ]
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "file",
                        fn: function ({ file }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "container_image_upload" },
                              [
                                _c("TagFlag", { attrs: { title: "Mới" } }),
                                _c("img", {
                                  staticClass: "el-upload-list__item-thumbnail",
                                  attrs: {
                                    src: _vm.getPreview(file),
                                    alt: "Ảnh mới",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "upload-thumbnail-actions" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "upload-thumbnail-action",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "Xem ảnh " + file.name,
                                          title: "Xem ảnh",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handlePictureCardPreview(
                                              file
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-zoom-in",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                    !_vm.disabled
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "upload-thumbnail-action upload-thumbnail-action--delete",
                                            attrs: {
                                              type: "button",
                                              "aria-label":
                                                "Bỏ ảnh " + file.name,
                                              title: "Bỏ ảnh",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleRemove(file)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("div", { staticClass: "upload-help-text" }, [
                    _vm._v(
                      "\n          JPG/PNG, tối đa 5MB/ảnh · Tối đa " +
                        _vm._s(_vm.albumMaxNumber) +
                        " ảnh\n        "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  staticClass: "album-studio-upload-preview",
                  attrs: {
                    title: "Xem ảnh mới",
                    width: "70%",
                    visible: _vm.dialogVisible,
                    top: "32px",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "actions-wrap" },
            [
              _c(
                "Phase2ActionButton",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.loadingButton,
                    disabled: _vm.loadingButton || _vm.compressingCount > 0,
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitUpload("createAlbumRequest")
                    },
                  },
                },
                [_vm._v("\n        Lưu thay đổi\n      ")]
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link cancel-link",
                  attrs: { to: "/album-v2" },
                },
                [
                  _c(
                    "Phase2ActionButton",
                    {
                      attrs: {
                        type: "default",
                        size: "small",
                        icon: "el-icon-circle-close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createEmployeeDialog()
                        },
                      },
                    },
                    [_vm._v("\n          Hủy\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.showCreateProgress
        ? _c(
            "div",
            {
              staticClass:
                "album-create-progress-overlay album-studio-progress",
              attrs: { role: "status", "aria-live": "polite" },
            },
            [
              _c(
                "div",
                { staticClass: "album-create-progress-card" },
                [
                  _c("i", {
                    staticClass:
                      "el-icon-loading album-create-progress-card__icon",
                  }),
                  _c(
                    "h3",
                    { staticClass: "album-create-progress-card__title" },
                    [_vm._v(_vm._s(_vm.createProgressTitle))]
                  ),
                  _c(
                    "p",
                    { staticClass: "album-create-progress-card__message" },
                    [_vm._v(_vm._s(_vm.createProgressMessage))]
                  ),
                  _c("el-progress", {
                    staticClass: "album-create-progress-card__bar",
                    attrs: {
                      percentage: _vm.percentage,
                      color: _vm.colors,
                      "show-text": false,
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "album-create-progress-card__percent" },
                    [_vm._v(_vm._s(_vm.percentage) + "%")]
                  ),
                  _c("p", { staticClass: "album-create-progress-card__note" }, [
                    _vm._v("Vui lòng không đóng trang trong quá trình xử lý."),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("AddStudentInAlbumDialog", {
        attrs: {
          getAppTypeUserLogin: _vm.getAppTypeUserLogin,
          isAddStudentInAlbumDialog: _vm.isAddStudentInAlbumDialog,
        },
        on: {
          closeDialog: _vm.closeAddStudentInAlbumDialog,
          updateIdKidApply: _vm.updateIdKidApply,
          confirmData: _vm.handleConfirmKidsApply,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }